$(document).ready(function () {
    let post_ids = ["2230", "225"];
    if (post_ids.indexOf($('body').attr('data-post-id')) >= 0) {
        $('.brokers-list .broker .broker-title').each(function (idx, title) {
            title = $(title);

            if (title.text().length > 35) {
                title.parent().addClass('long-title');
            }
        })
    }
})
